import { Navigate } from 'react-router-dom';

const ProtectedCustomerRoute = ({ children, currentUser }) => {
  // Multiple ways to check if user is delivery agent
  const isDeliveryAgent = 
    currentUser?.is_delivery_agent || 
    currentUser?.user_type === 'delivery_agent' ||
    (currentUser && currentUser.delivery_agent_id) ||
    false;
  
  console.log('🛡️ Route Protection Check:', {
    currentUser,
    isDeliveryAgent,
    pathname: window.location.pathname
  });

  if (isDeliveryAgent) {
    return <Navigate to="/delivery-dashboard" replace />;
  }
  
  return children;
};

export default ProtectedCustomerRoute;